import { FlagOutlined, RocketOutlined } from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/campaign-universal",
    name: "campaign_universal.title",
    icon: RocketOutlined,
    component: lazy(() => import("./UniversalCampaignContainer")),
    defaultSearch: "s=clicks.desc",
    exact: true,
    permissions: [
      [Resource.CAMPAIGN_UNIVERSAL, Permission.VIEW],
      [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_VIEW],
    ],
    placeholderConfig: {
      picker: true,
    },
  },
  {
    path: "/campaign-universal/:id/edit",
    name: "campaign_universal.title",
    hideInMenu: true,
    exact: true,
    component: lazy(() => import("./pages/UniversalCampaignCompose")),
    permissions: [
      [Resource.CAMPAIGN_UNIVERSAL, Permission.UPDATE],
      [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_UPDATE],
    ],
  },
  {
    path: "/campaign-universal/:id/:tab",
    name: "campaign_universal.title",
    hideInMenu: true,
    exact: true,
    component: lazy(() => import("./pages/UniversalCampaignDetail")),
    permissions: [
      [Resource.CAMPAIGN_UNIVERSAL, Permission.VIEW],
      [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_VIEW],
    ],
  },
];

export default routes;
